import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadfileService {

 
  apiUrl = environment.serverUrl;


  constructor(private http: HttpClient) { }
    upload(file: File): Observable<HttpEvent<any>> {
      const formData: FormData = new FormData();
       formData.append('file', file);
        const req = new HttpRequest('POST', `${this.apiUrl}/upload`, formData, {
       reportProgress: true,
      responseType: 'json'
    });
  return this.http.request(req);
  }

  uploadFile(id,formData) {
    return this.http.post<any>(this.apiUrl + `/upload/excel/file/${id}`, formData);
  }

  uploadUserFile(id,formData) {
    return this.http.post<any>(this.apiUrl + `/upload/user/file/${id}`, formData);
  }
  
  getFileAll() {
    return this.http.get<File[]>(`${this.apiUrl}/admin/user/all`);
  }

  deleteFile(id) {
    return this.http.delete<File>(`${this.apiUrl}/admin/user/file/delete/`+id);
  }
}
